import React, { ComponentType, FunctionComponent } from "react";
import useRouterContext from "../hooks/useRouterContext";
import { extractParams, pathMatch } from "../utils";

export interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: ComponentType<any>;
  componentProps?: Record<string, unknown>;
  exact?: boolean;
  path: string;
}

const Route: FunctionComponent<Props> = ({
  component: RoutedComponent,
  componentProps = {},
  exact = true,
  path,
}) => {
  const context = useRouterContext();
  const locationHash = context.history.location.hash;

  if (locationHash && pathMatch(path, `${context.path}${locationHash}`, exact)) {
    const params = extractParams(path, `${context.path}${locationHash}`);

    return <RoutedComponent {...params} {...componentProps} />;
  }

  if (pathMatch(path, context.path, exact)) {
    const params = extractParams(path, context.path);

    return <RoutedComponent {...params} {...componentProps} />;
  }

  return null;
};

export default Route;
